import * as React from "react";

type Props = {
  snapminUrl: string;
  children?: any;
};

const snapminLink = (props: Props) => (
  <span>
    {props.children}
    <a
      style={{ marginLeft: "6px" }}
      target="_blank"
      rel="noopener noreferrer"
      className="blueLink"
      href={props.snapminUrl}
    >
      <i className="fa fa-info-circle" />
    </a>
  </span>
);

export default snapminLink;
